import {Provider} from 'react-redux';
import {renderElement, unmountElement} from '@Utils/root-element.util';
import {EmailMakerVersionHistoryPanel} from '@Components/email-maker-version-history-panel';
import type {EmailMakerVersionHistoryPanelProps} from '@Components/email-maker-version-history-panel/email-maker-version-history-panel.types';
import {VersionHistoryOnboardingPopup} from '@Components/version-history-onboarding-popup/version-history-onboarding-popup';

window.PMW.mergePMW(window.PMW, {
  renderVersionHistorySidePanel(containerElement: HTMLElement, opts: EmailMakerVersionHistoryPanelProps): void {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerVersionHistoryPanel {...opts} />
      </Provider>
    );
  },

  renderVersionHistoryOnboardingPopup(containerElement: HTMLElement, opts: {onClose: () => void}): void {
    renderElement(containerElement, <VersionHistoryOnboardingPopup onClose={opts.onClose} />);
  },

  unmountVersionHistoryOnboardingPopup(containerElement: HTMLElement): void {
    unmountElement(containerElement);
  },
});
